/* eslint-disable */
import React from 'react';
// import Img from 'gatsby-image';
import { css } from 'react-emotion';
import { Box } from '../components/Layout';
import { Link, Timestamp } from '../components/Misc';
import { Footer } from '../components/Footer';
import ribbons from '../components/Ribbon/ribbon.module.css'

// const imgStyle = css`
//   border-radius: 5px;
//   margin-bottom: 1.7rem;
// `;

const linkStyles = css`
  box-shadow: none;
`;

const InstitutionsIndex = ({ data }) => {
  const { edges: institutions } = data.allAirtableProfile;
  return (
    <Box>
    <div className={ribbons.cornerRibbon}>Beta</div> 
      <Box
        width={[1, 1, 720]}
        m={['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto']}
        px={[3, 3, 0]}
      >
        <h1>Institutions</h1>
        <Box>
          {institutions
            .filter(post => post.node.InstitutionName.length > 0)
            .map(({ node: post }) => {
              return (
                <Box key={post.id}>
                  <Link to={post.URL_slug} className={linkStyles}>
                    Start date: <Timestamp>{post.ProgramStartDate}</Timestamp>
                    <h3>{post.InstitutionName}</h3>
                    <p>Student Disciplines: {post.StudentDisciplines ? (post.StudentDisciplines.map((d) => {return(d + ", ");} )) : " "}</p>
                  </Link>
                </Box>
              );
            })}
        </Box>
      </Box>
      <Footer/>
    </Box>
  );
};

export const pageQuery = graphql`
  query InstitutionsQuery {
    allAirtableProfile(sort: { order: ASC, fields: [InstitutionName] }) {
      edges{
        node{
          slug
          URL_slug
          InstitutionName
          ModulesInScope
          ModulesInProgramDuration
          ProgramStartDate
          StudentDisciplines
          logo {
            url
          }
        }
      }
    }
  }
`;

export default InstitutionsIndex;



// WEBPACK FOOTER //
// ./src/pages/institutions.js